import StyledLink from '../StyledLink'
import makeQueryString from './makeUrl/makeUrl'
import {
  ASSETS,
  EDIT,
  GIT_CONNECTIONS,
  SPACES
} from '../routes'

interface Params {
  importTo?: string
}

interface Props {
  children: React.ReactNode
  spaceId: string
}

const LinkToSpaceAssetsGitConnections = ({
  children,
  spaceId,
  ...params
}: Props & Params) => {
  const url = `/${SPACES}/${spaceId}/${ASSETS}/${EDIT}/${GIT_CONNECTIONS}`

  return (
    <StyledLink to={makeQueryString(url, { ...params })}>
      {children}
    </StyledLink>
  )
}

export default LinkToSpaceAssetsGitConnections
